"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvatarStub = void 0;
const getAvatarStub = (authorName) => { var _a; return ((_a = authorName[0]) !== null && _a !== void 0 ? _a : 'A').toUpperCase(); };
exports.getAvatarStub = getAvatarStub;
